let state = {
  activedIndex: 0,
  applicantInfo:{},
};

export default state;
